<template>
  <Loading
    class="loader"
    :state="loading"
  >
    <div
      class="depth"
    >
      <div
        v-for="d in 3"

        :class="{ [ 'depth' + d ]: true, selected: depth == d }"
        :key="d"

        :title="$t( 'depth' + d )"

        @click="depth = d"
      >
        <Icon
          :symbol="'graphDepth' + d"
          :size="null"
        />
      </div>
    </div>

    <GraphShow
      class="graph"

      :id="id"
      :ttl="ttl"
    >
    </GraphShow>
  </Loading>

</template>

<script>
  import utils from "@/utils";
  import dates from "@/dates";
  import fbu from "../frontbackUtils.js";

  import Loading from "@/components/Loading";

  import GraphShow from "@/components/GraphShow/GraphShow.vue";
  import Button from "@/components/Button";
  import Icon from "@/components/Icon";

  export default {
		name:  "ObjectViewGraphView",

    components: {
		  Loading,
      GraphShow,
      Button,
      Icon
    },

    utils,

    i18n: {
      messages: {
        ru: {
          depth1:                      "глубина связей 1 - только соседи",
          depth2:                      "глубина связей 2 - соседи и их соседи",
          depth3:                      "глубина связей 3 - соседи, их соседи и их соседи",
        },

        en: {
          depth1:                      "references depth 1 - siblings only",
          depth2:                      "references depth 2 - siblings and siblings of their siblings",
          depth3:                      "references depth 3 - siblings, their siblings and siblings of their siblings",
        },

        kz: {
          depth1:                      "сілтемелер тереңдігі 1 - тек ағайындылар",
          depth2:                      "сілтемелер тереңдігі 2 - олардың аға-әпкелері мен іні-қарындастары",
          depth3:                      "Анықтама тереңдігі 3 - аға-әпкелері, олардың аға-әпкелері және іні-қарындастарының бауырлары",
        }
      }
    },

    props: {
      id: {
		    type: String,
        mandatory: true
      },

      endpoint: {
        type: String,
        mandatory: true
      }
    },

    data() {
		  return {
		    loading:  true,
        ttl:      null,
        depth:     1
      };
    },

    methods: {
    },

    watch: {
		  depth: {
		    immediate: true,
        async handler() {
          this.loading = true;

          try {
            const ans = await this.$options.api.post.json(
              "/subgraph",
              {
                ...this.queryStd,
                id:       this.id,
                endpoint: this.endpoint,
                clientId: this.clientId,
                depth:    this.depth,
                lang:     this.langInterf
              }
            );

            if ( ans && ans.ttl ) this.ttl = ans.ttl;
          }
          catch ( e ) {
            console.error( e );
            this.ttl = null;
          }

          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped>
  .depth {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 1em;
  }

  .depth > * {
    display: inline-block;
    margin-right: 2em;
    padding: 0.5em;
    border: solid 2px transparent;
    border-radius: 0.2em;
    height: 2em;
    overflow: hidden;
    cursor: pointer;
    transition: all .2s ease-in-out;
  }

  .depth > *:hover {
    background-color: #D0EBF5;
  }

  .depth > *.selected {
    border-color: #007BC1;
  }

  .depth > *:last-child {
    margin-right: 0;
  }

  .depth svg {
    margin-top: -1.65em;
    height: 4em;
  }
</style>